import { Pagination } from '@/domain/entities/Pagination'
import { Image, ImageData } from '@/domain/entities/GalleryImage'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class GalleryImageDataMapper extends BaseResponseMapper {
  public convertGalleryImageFromApi(result: AxiosResponse<any>): Image {
    const { data } = result
    return new Image(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new ImageData(
            val.id,
            val.name,
            val.category,
            val.link,
            val.created_at,
            val.updated_at
          )
      )
    )
  }
}
